const l = (a, e = "") => !a || !a.firstName && !a.fullName && !a.userFirstName && !a.userLastName ? e : a.fullName ? a.fullName : `${a.firstName || a.userFirstName} ${a.lastName || a.userLastName || ""}`, i = (a, e) => `${a}${e ? ` ${e}` : ""}`, n = (a, e = "") => {
  var t, m;
  if (!a || !a.firstName && !a.fullName && !a.userFirstName && !a.userLastName)
    return e;
  const r = a.firstName || a.userFirstName || "", s = ((t = a.lastName) == null ? void 0 : t.charAt(0)) || ((m = a.userLastName) == null ? void 0 : m.charAt(0)) || "";
  return `${r} ${s}`;
}, N = (a) => a && {
  ...a,
  fullName: l(a)
}, u = (a) => a && a.map((e) => N(e)), f = (a, e) => !!a && !!e && a.id === e.id, c = (a) => ({
  id: a.id,
  firstName: "Anonymous",
  fullName: "Anonymous"
}), d = (a) => a ? {
  id: a.surrogateID,
  firstName: a.fullName,
  fullName: a.fullName
} : void 0, F = (a) => {
  var e;
  return !!a && "surrogateID" in a && !!((e = a.surrogateID) != null && e.length);
};
export {
  N as addFullName,
  u as addFullNames,
  c as anonymize,
  f as areEqual,
  l as fullName,
  i as fullName2,
  n as getFirstNameAndInitial,
  d as guestToUser,
  F as isGuest
};
